import { Button, Typography } from "@mui/material";
import { useContext, useState } from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

import { CameraButton } from "./CameraButton";
import { ImageCard } from "./ImageCard";

import "./index.scss";
import { MedphotoContext } from "medphoto.context";
import { fileApi } from "config";

export const CameraInputPage = ({ onExit, pnr }: { onExit: () => void; pnr: string }) => {
  const { unit } = useContext(MedphotoContext);
  const [images, setImages] = useState<UploadImage[]>([]);

  const handleAddImage = async (img: UploadImage) => {
    let form_data = new FormData();
    form_data.append("image", img.inputFile);
    form_data.append("pnr", pnr);

    const processing_res = await fileApi.post("patient/medphoto-image-processing/", form_data);

    const { img_b64, mime, name } = processing_res.data as { img_b64: string; mime: string; name: string };

    const imageContent = window.atob(img_b64);
    const buffer = new ArrayBuffer(imageContent.length);
    const view = new Uint8Array(buffer);
    for (let n = 0; n < imageContent.length; n++) {
      view[n] = imageContent.charCodeAt(n);
    }

    const blob = new Blob([buffer], { type: mime });

    const imageFile = new File([blob], name, { type: mime });

    const parsedImage: UploadImage = {
      filename: name,
      inputFile: imageFile,
      data: `data:${mime};base64,${img_b64}`,
      "mime-type": mime,
    };
    setImages([...images, parsedImage]);
  };

  const handleRemoveImage = (img: UploadImage) => {
    setImages([...images.filter((image) => image.filename !== img.filename)]);
  };

  return (
    <div className="camera-input-page">
      <header>
        <Button startIcon={<ArrowBackIosNewIcon />} onClick={onExit}>
          Gå tillbaka
        </Button>
        <div>
          <Typography variant="h1" color="primary">
            Patient: {pnr}
          </Typography>
          <Typography variant="h1" color="primary">
            {unit?.show_name}
          </Typography>
        </div>
      </header>
      <article>
        <div>
          <CameraButton handleImageInput={(data) => handleAddImage(data)} />
          {images.map((img, i) => (
            <ImageCard image={img} pnr={pnr} onRemove={() => handleRemoveImage(img)} key={i} />
          ))}
        </div>
      </article>
    </div>
  );
};
